import React, { memo } from 'react';
export function Footer() {
  return <footer className="bg-[#15193D] text-[#FBF3EA] py-16 px-6 border-t border-white/10" data-id="element-43">
      <div className="max-w-7xl mx-auto" data-id="element-44">
        <div className="grid md:grid-cols-4 gap-12 mb-16" data-id="element-45">
          {/* Logo & Description */}
          <div className="md:col-span-2" data-id="element-46">
            <div className="mb-6 inline-block" data-id="element-47">
              <img src="https://cdn.magicpatterns.com/uploads/4Prt8voGX9NE1GpiEStH1D/Frame_16865625112.png" alt="Famday" className="h-24 w-24 rounded-3xl object-cover shadow-lg" data-id="element-48" />
            </div>
            <p className="text-[#FBF3EA]/70 max-w-md text-lg leading-relaxed font-medium" data-id="element-49">
              The all-in-one family organization app. Keep everyone connected
              with shared calendars, to-dos, and memories.
            </p>
          </div>

          {/* Product Links */}
          <div data-id="element-50">
            <h3 className="font-bold text-xl mb-6 tracking-wide" data-id="element-51">Product</h3>
            <ul className="space-y-4 text-[#FBF3EA]/70 font-medium" data-id="element-52">
              <li data-id="element-53">
                <a href="#features" className="hover:text-white transition-colors" data-id="element-54">
                  Features
                </a>
              </li>
              <li data-id="element-55">
                <a href="#download" className="hover:text-white transition-colors" data-id="element-56">
                  Download
                </a>
              </li>
              <li data-id="element-57">
                <a href="#" className="hover:text-white transition-colors" data-id="element-58">
                  Pricing
                </a>
              </li>
            </ul>
          </div>

          {/* Legal Links */}
          <div data-id="element-59">
            <h3 className="font-bold text-xl mb-6 tracking-wide" data-id="element-60">Legal</h3>
            <ul className="space-y-4 text-[#FBF3EA]/70 font-medium" data-id="element-61">
              <li data-id="element-62">
                <a href="https://go.pixo.co/famcal-privacy" target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors" data-id="element-63">
                  Privacy Policy
                </a>
              </li>
              <li data-id="element-64">
                <a href="https://go.pixo.co/famcal-terms" target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors" data-id="element-65">
                  Terms of Service
                </a>
              </li>
              <li data-id="element-66">
                <a href="mailto:support@pixo.co" className="hover:text-white transition-colors" data-id="element-67">
                  Contact Support
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="border-t border-white/10 pt-8 text-center text-[#FBF3EA]/50 font-medium" data-id="element-68">
          <p data-id="element-69">&copy; 2026 Famday. All rights reserved.</p>
        </div>
      </div>
    </footer>;
}